import { useContext } from "react";
import { Spinner } from "@/components/ui/spinner";
import MerchantContext from "../../contexts/MerchantContext";
import { trpc } from "../../trpc";
import EmployeeCalComCard from "./EmployeeCalComCard";

const CalendarsConfiguration = (): JSX.Element => {
  const { merchantId } = useContext(MerchantContext);

  const { data: employees, isLoading: isLoadingEmployees } = trpc.employees.list.useQuery(
    { merchantId },
    { enabled: !!merchantId }
  );

  if (isLoadingEmployees) {
    return (
      <div className="flex h-full items-center justify-center">
        <Spinner />
      </div>
    );
  }

  if (!employees || employees.length === 0) {
    return (
      <div className="flex flex-col gap-6">
        <div>
          <h2 className="mb-2 text-2xl font-bold">
            Integración de Calendarios
          </h2>
          <p className="mb-6 text-gray-600">
            Configura la integración con Cal.com para sincronizar las citas con los calendarios de
            tus asesores
          </p>
        </div>
        <div className="rounded-xl border border-gray-200 bg-white p-6">
          <p className="text-gray-600">
            No hay empleados registrados. Agrega empleados para configurar sus calendarios.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-6">
      <div>
        <h2 className="mb-2 text-2xl font-bold">
          Integración de Calendarios
        </h2>
        <p className="mb-6 text-gray-600">
          Configura la integración con Cal.com para sincronizar las citas con los calendarios de tus
          asesores
        </p>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
          {employees.map((employee) => (
            <EmployeeCalComCard key={employee.id} employee={employee} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default CalendarsConfiguration;
